import React, { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
function ProjectCancel() {
  const category = useLocation().pathname.split("/")[1];

  return (
    <div className="projectCancel-popup">
      <div className="wrapper">
        <div className="title">
          {category === "project" ? "프로젝트" : "밋업"} 모집을 <br />
          일시중지 하겠습니까?
        </div>
        <div className="sub">
          모집 일시중지 시 홈페이지 <br />
          리스트에서 블라인드 처리 됩니다
        </div>
        <div className="button"> 프로젝트 일시중지</div>
      </div>
    </div>
  );
}

export default ProjectCancel;
